/** Shared import-level error contract for modal and background widget surfaces. */

export type ImportSummaryErrorKey =
  | 'importErrors.summaryPartialFailure'
  | 'importErrors.timeout'
  | 'importErrors.accountNotImportable'
  | 'importErrors.adAccountLimitReached'
  | 'importErrors.importInProgress'

export const AD_ACCOUNT_LIMIT_REACHED_ERROR_CODE = 'AD_ACCOUNT_LIMIT_REACHED'

export const IMPORT_IN_PROGRESS_ERROR_CODE = 'IMPORT_IN_PROGRESS'

/** Client-side code for a fully silent import stream past its watchdog budget. */
export const IMPORT_STREAM_TIMEOUT_ERROR_CODE = 'import_stream_timeout'

/** Terminal code for a completed import containing per-account failures. */
export const IMPORT_PARTIAL_FAILURE_ERROR_CODE = 'import_partial_failure'

const IMPORT_SUMMARY_ERROR_KEYS: Record<string, ImportSummaryErrorKey> = {
  [IMPORT_PARTIAL_FAILURE_ERROR_CODE]: 'importErrors.summaryPartialFailure',
  [IMPORT_STREAM_TIMEOUT_ERROR_CODE]: 'importErrors.timeout',
  ACCOUNT_NOT_IMPORTABLE: 'importErrors.accountNotImportable',
  [AD_ACCOUNT_LIMIT_REACHED_ERROR_CODE]: 'importErrors.adAccountLimitReached',
  [IMPORT_IN_PROGRESS_ERROR_CODE]: 'importErrors.importInProgress',
}

export function resolveImportSummaryErrorKey(
  errorCode: string | null | undefined,
): ImportSummaryErrorKey | null {
  if (!errorCode || !Object.hasOwn(IMPORT_SUMMARY_ERROR_KEYS, errorCode)) return null
  return IMPORT_SUMMARY_ERROR_KEYS[errorCode]
}
